import { BaseMenu } from './BaseMenu';
import { MenuItemType } from '@Common/Enums';

export class MenuTab extends BaseMenu {
    constructor(param) {
        super(
            $.extend(
                {
                    bottomTab: false,
                    isVertical: false,
                    sortable: false
                },
                param
            )
        );
    }

    _init() {
        super._init();
        this._root.addClass('menu-tab-control');
        this._root.css({ lineHeight: 'normal' });
        this._param.bottomTab && this._root.addClass('bottom-tab');
    }

    addChildrens(node) {
        node.control.childrenUl = $('<ol />');
        node.control.childrenUl.addClass(this.param.contentStyle).addClass(this.param.defaultContentStyle);

        _(node.children).forEach(
            function (i) {
                this._createItem(i);
                i.control.li && i.control.li.appendTo(node.control.childrenUl);
            }.bind(this)
        );
    }

    adjust(width, height) {
        super.adjust(width, height);

        let rootUlH;
        if (this._param.bottomTab) {
            rootUlH = this._rootUl.height();

            setChildrenPosition(this._treeStore.nodes());
        }

        function setChildrenPosition(nodes) {
            _(nodes).forEach(function (i) {
                i.control &&
                    i.control.childrenUl &&
                    i.control.childrenUl.elementInDOM() &&
                    i.control.childrenUl.css({ bottom: (i.level + 1) * rootUlH });

                setChildrenPosition(i.nodes() || []);
            });
        }

        if (this._root.elementInDOM()) {
            const h = this._root.find('.li-content:first').outerHeight(true);
            this._treeStore.forEachNode(
                function (i) {
                    if (i.control.li.elementInDOM() && (i.data.separator || i.data.menuItemType == MenuItemType.separator)) {
                        i.control.li.height(h);
                    }
                }.bind(this)
            );
        }
    }

    _clickHandler(node, leftToRight, event) {
        super._clickHandler(node, leftToRight, event);

        const root = this._root;

        // hide childrens from other item
        function hideULChildren(items) {
            _(items).forEach(function (i) {
                if (
                    i.control &&
                    i.control.childrenUl &&
                    i.control.childrenUl !== node.control.childrenUl &&
                    i.control.childrenUl.elementInDOM() &&
                    node.level <= i.level
                ) {
                    i.control.childrenUl.detach();
                }

                if (i.control && i.control.childrenUl && i.level == node.level) {
                    i.control.childrenUl.removeClass('opened');
                }

                hideULChildren(i.nodes() || []);
            });
        }

        hideULChildren(this._treeStore.nodes());

        node.control.childrenUl.appendTo(root);
        node.control.childrenUl.addClass('opened');

        function showChildrenUl(nodes) {
            _(nodes)
                .filter(function (i) {
                    return i.control && i.control.childrenUl && !i.control.childrenUl.elementInDOM() && i.control.childrenUl.hasClass('opened');
                })
                .forEach(
                    function (i) {
                        i.control.childrenUl.appendTo(root);
                    }.bind(this)
                );
        }

        showChildrenUl(node.nodes() || []);

        this.adjust(null, null);
    }
}
